package com.wintermar.inspection.core.ui.component.input

import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.input.InputTransformation
import androidx.compose.foundation.text.input.TextObfuscationMode
import androidx.compose.foundation.text.input.maxLength
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedSecureTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.testTag
import com.wintermar.inspection.core.ui.component.input.util.InputColor
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.hide_password
import inspection.composeapp.generated.resources.ic_eye
import inspection.composeapp.generated.resources.ic_eye_off
import inspection.composeapp.generated.resources.show_password
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun InputSecureText(
    state: InputState,
    modifier: Modifier = Modifier
) {
    val dimension = LocalAppTheme.current.dimension
    val textStyles = LocalAppTheme.current.textStyle.body.small
    var visibility by remember { mutableStateOf(false) }
    val focusManager = LocalFocusManager.current

    OutlinedSecureTextField(
        state = state.value,
        textObfuscationMode = if (visibility) TextObfuscationMode.Visible else TextObfuscationMode.Hidden,
        textStyle = textStyles,
        enabled = state.enabled,
        shape = RoundedCornerShape(dimension.radius.md),
        colors = InputColor.default(),
        isError = state.isError,
        contentPadding = PaddingValues(
            horizontal = dimension.spacing.space4,
            vertical = dimension.spacing.space3
        ),
        placeholder = { Text(state.placeholder, style = textStyles) },
        supportingText = { if (state.message.isNotBlank()) Text(state.message) },
        inputTransformation = state.maxChar?.let {
            InputTransformation.maxLength(it)
        },
        trailingIcon = {
            Icon(
                painter = painterResource(if (visibility) Res.drawable.ic_eye_off else Res.drawable.ic_eye),
                contentDescription = stringResource(if (visibility) Res.string.hide_password else Res.string.show_password),
                modifier = Modifier
                    .testTag("secure_visibility_toggle")
                    .clip(
                        shape = RoundedCornerShape(
                            size = LocalAppTheme.current.dimension.radius.full
                        )
                    )
                    .clickable(
                        onClick = {
                            visibility = !visibility
                        },
                    )
            )
        },
        onKeyboardAction = {
            focusManager.clearFocus()
        },
        modifier = modifier
            .onFocusChanged { focusState ->
                if (focusState.isFocused) {
                    state.hasFocus = true
                    return@onFocusChanged
                }

                if (!focusState.isFocused && state.hasFocus) {
                    state.hasFocus = false
                    state.onBlurChanged()
                }
            },
    )
}
